//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum OpportunityCrossType {
	Referrer = 0,
	Partner = 1,
	Competitor = 2
}
